import React, { createContext, useCallback, useContext, useState } from "react";

interface IContext {
    children: React.ReactNode;
}

type SetValueFn = (value: any) => void;
type GetValueFn = () => any;

interface FormProviderProps {
    children: React.ReactNode;
    initialData?: Record<string, any>;
}

interface IProps {

    getValue: GetValueFn;
    setValue: SetValueFn;
}
type FormContextType = {
    registerField: (name: string, setContent: SetValueFn, getContent: GetValueFn, onStart?: Function) => void;
    onSubmit: () => any;

};

const FormContext = createContext<FormContextType>({} as FormContextType);



export const useFormContext = () => {
    const context = useContext(FormContext);
    if (!context) throw new Error('useFormContext must be used within a FormProvider');
    return context;
};

const FormProvider: React.FC<FormProviderProps> = ({ children, initialData = {} }) => {


    const [registerField, setRegisterField] = useState<Record<string, IProps>>({});

    const addFieldToRegister = (name: string, setContent: SetValueFn, getContent: GetValueFn, onStart?: Function) => {


        const checker = { ...registerField };

        setRegisterField(state => ({
            ...state, [name]: {
                getValue: getContent,
                setValue: setContent,
                onStart: onStart
            }
        }))

        const content = getContent();

        if (initialData?.[name] && !checker[name]) {
            if (onStart) {
                onStart(initialData?.[name])
            }
            else {
                setContent(initialData?.[name])
            }

        }





    }

    const onSubmit = () => {

        const formData: Record<string, any> = {};
        Object.keys(registerField).forEach(key => {
            formData[key] = registerField[key].getValue();

        });
        return formData;

    }


    return (
        <FormContext.Provider value={{ registerField: addFieldToRegister, onSubmit }}>
            {children}
        </FormContext.Provider>
    );

}


function useForm(): FormContextType {
    const context = useContext(FormContext);

    if (!context) {
        throw new Error('useForm must be used within an FormProvider');
    }

    return context;
}

export { FormProvider, useForm };

